module.exports = __webpack_public_path__ + "img/cheveronDownBlue.340b124c.svg";